import { Tag as AntdTag, type TagProps } from 'antd'
import Text from '../../general/Typography/Text/Text'

/**
 *
 * this is Antd Tag component with Text component inside
 * for more documentation check Antd docs
 *
 */
const Tag = (props: TagProps) => {
  const { children, ...restProps } = props

  return (
    <AntdTag {...restProps}>
      <Text level={2}>{children}</Text>
    </AntdTag>
  )
}

export default Tag
